import React from 'react';
import useDashboardApexChart from '../../hook/useDashboardApexChart';

const ReadersGraph = ({ graphData, newUsers }) => {

      const { createChartSix } = useDashboardApexChart();

      console.log("Readers graph ====>", graphData);

      const {
            newReaders = 0,
            trendReaders = [],
            trendNewReaders = [],
            xAxisLabels = []
      } = graphData || {};

      const todayReaders =
            newUsers ??
            (trendReaders.length ? trendReaders[trendReaders.length - 1] : 0);

      return (
            <div className="col-xxl-12">
                  <div className="card radius-8 border-0 p-20">
                        <div className="row gy-4">

                              {/* STAT CARDS */}
                              <div className="col-xxl-3 d-flex flex-column">

                                    <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-1 mb-12 flex-fill">
                                          <div className="card-body p-0">
                                                <div className="d-flex align-items-center gap-2 mb-12">
                                                      <span className="mb-0 w-48-px h-48-px bg-base text-primary text-2xl d-flex justify-content-center align-items-center rounded-circle h6">
                                                            <i className="ri-user-3-fill"></i>
                                                      </span>
                                                      <span className="fw-medium text-secondary-light text-lg">
                                                            Today Readers
                                                      </span>
                                                </div>

                                                <div className="d-flex align-items-center justify-content-between">
                                                      <h5 className="fw-semibold mb-0">{todayReaders}</h5>
                                                </div>
                                          </div>
                                    </div>

                                    <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-2 mb-12 flex-fill">
                                          <div className="card-body p-0">
                                                <div className="d-flex align-items-center gap-2 mb-12">
                                                      <span className="mb-0 w-48-px h-48-px bg-base text-purple text-2xl d-flex justify-content-center align-items-center rounded-circle h6">
                                                            <i className="ri-checkbox-circle-fill"></i>
                                                      </span>
                                                      <span className="fw-medium text-secondary-light text-lg">
                                                            New Readers
                                                      </span>
                                                </div>

                                                <div className="d-flex align-items-center justify-content-between">
                                                      <h5 className="fw-semibold mb-0">{newReaders}</h5>
                                                </div>
                                          </div>
                                    </div>

                              </div>

                              {/* CHART */}
                              <div className="col-xxl-9">
                                    <div className="card-body p-0">
                                          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                                                <h6 className="mb-2 mt-1 fw-bold text-lg">Readers Trend</h6>
                                          </div>

                                          <ul className="d-flex justify-content-center mt-3 gap-3 stats-legend">
                                                <li className="d-flex align-items-center gap-2">
                                                      <span className="w-12-px h-12-px rounded-circle bg-primary-600" />
                                                      Today Readers<span className="legend-value">: <b>{todayReaders}</b></span>
                                                </li>
                                                <li className="d-flex align-items-center gap-2">
                                                      <span className="w-12-px h-12-px rounded-circle bg-purple" />
                                                      New Readers<span className="legend-value">: <b>{newReaders}</b></span>
                                                </li>
                                          </ul>

                                          <div className="mt-40">
                                                <div id="readersChart" className="apexcharts-tooltip-style-1">
                                                      {createChartSix('#487fff', '#9b59b6', trendReaders, trendNewReaders, xAxisLabels, 'Today Readers', 'New Readers')}
                                                </div>
                                          </div>
                                    </div>
                              </div>

                        </div>
                  </div>
            </div>
      );
};

export default ReadersGraph;